import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { authStorage } from '../utils/authStorage';
import '../pages/sidebar-fix.css';

const Sidebar = ({ sidebarCollapsed, setSidebarCollapsed, toggleSidebar }) => {
  const location = useLocation();
  const pathname = location.pathname;

  const [activeStates, setActiveStates] = useState({
    lpdashActive: false,
    dashActive: false,
    ntcDashActive: false,
    dashboardActive: false,
    upcomingActive: false,
    activeActive: false,
    completedActive: false,
    investedActive: false,
    unreleasedActive: false,
    projectActive: false,
    distribActive: false,
    calendarActive: false,
    tokenActive: false,
    docsActive: false,
    showSidebar: true
  });

  const [expandedMenus, setExpandedMenus] = useState({
    dashboard: false,
    projects: false,
    invested: false,
    distribution: false
  });

  const [userData, setUserData] = useState({ role: 1 });

  useEffect(() => {
    const loginData = authStorage.getLoginData();
    if (loginData && typeof loginData === 'object') {
      setUserData(loginData);
    }
    if (authStorage.getDirectLink() === '1') {
      setActiveStates(prev => ({ ...prev, showSidebar: false }));
    }
  }, []);

  useEffect(() => {
    setActiveStates(prev => ({
      ...prev,
      lpdashActive: pathname === '/lp-dashboard',
      dashActive: pathname === '/investor-dashboard',
      ntcDashActive: pathname === '/ntc-dashboard',
      dashboardActive: pathname === '/lp-dashboard' || pathname === '/investor-dashboard' || pathname === '/ntc-dashboard',
      upcomingActive: pathname === '/upcoming' || pathname.startsWith('/allocation-sheet'),
      activeActive: pathname === '/active',
      completedActive: pathname === '/completed',
      investedActive: pathname === '/invested' || pathname === '/ongoing',
      unreleasedActive: pathname === '/unreleased',
      projectActive: pathname.startsWith('/invested') ||
                    pathname.startsWith('/ongoing') ||
                    pathname.startsWith('/unreleased') ||
                    pathname.startsWith('/completed') ||
                    pathname.startsWith('/active') ||
                    pathname.startsWith('/upcoming') ||
                    pathname.startsWith('/allocation-sheet') ||
                    pathname.startsWith('/documents'),
      distribActive: pathname.startsWith('/vesting-calendar') || pathname.startsWith('/token-distribution'),
      calendarActive: pathname === '/vesting-calendar',
      tokenActive: pathname === '/token-distribution',
      docsActive: pathname === '/documents'
    }));

    setExpandedMenus(prev => ({
      dashboard: pathname === '/lp-dashboard' || pathname === '/investor-dashboard' || pathname === '/ntc-dashboard',
      projects: pathname.startsWith('/invested') ||
                pathname.startsWith('/ongoing') ||
                pathname.startsWith('/unreleased') ||
                pathname.startsWith('/completed') ||
                pathname.startsWith('/rejected-projects') ||
                pathname.startsWith('/active') ||
                pathname.startsWith('/upcoming') ||
                pathname.startsWith('/allocation-sheet') ||
                pathname.startsWith('/documents'),
      invested: pathname.startsWith('/invested') ||
                pathname.startsWith('/ongoing') ||
                pathname.startsWith('/unreleased') ||
                pathname.startsWith('/completed'),
      distribution: pathname.startsWith('/vesting-calendar') || pathname.startsWith('/token-distribution')
    }));
  }, [pathname]);

  useEffect(() => {
    if (sidebarCollapsed) {
      setExpandedMenus({
        dashboard: false,
        projects: false,
        invested: false,
        distribution: false
      });
    }
  }, [sidebarCollapsed]);

  const toggleMenu = (menuName) => {
    if (sidebarCollapsed) return;
    setExpandedMenus(prev => ({ ...prev, [menuName]: !prev[menuName] }));
  };

  const handleSignout = () => {
    authStorage.clearLoginData();
    window.location.href = '/';
  };

  const { dashboardActive, upcomingActive, projectActive, investedActive, unreleasedActive, completedActive,
          distribActive, showSidebar } = activeStates;

  return (
    <nav className="nxl-navigation">
      <div className="navbar-wrapper">
        <div className="m-header">
          <Link to="/investor-dashboard" className="b-brand">
            <img src="/assets/images/logo-transparent.png" alt="NTC Logo" className="logo logo-full" />
            <img src="/assets/images/icon.png" alt="NTC Logo" className="logo logo-abbr" />
          </Link>
        </div>
        <div className="navbar-content">
          <ul className="nxl-navbar">
            {showSidebar && (
              <li className={`nxl-item nxl-hasmenu ${expandedMenus.dashboard ? 'nxl-trigger' : ''} ${dashboardActive ? 'active' : ''}`}>
                <button type="button" className="nxl-link border-0 bg-transparent p-0 w-100 text-start" onClick={() => toggleMenu('dashboard')}>
                  <span className="nxl-micon"><i className="feather-airplay"></i></span>
                  <span className="nxl-mtext" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>Dashboard</span>
                  <span className="nxl-arrow" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>
                    <i className="feather-chevron-right"></i>
                  </span>
                </button>
                <ul className={`nxl-submenu ${expandedMenus.dashboard && !sidebarCollapsed ? 'show' : ''}`}>
                  {(userData.role === 1 || userData.role === 6) && (
                    <li className={`nxl-item ${pathname === '/lp-dashboard' ? 'active' : ''}`}>
                      <Link to="/lp-dashboard" className="nxl-link">LPs</Link>
                    </li>
                  )}
                  <li className={`nxl-item ${pathname === '/investor-dashboard' ? 'active' : ''}`}>
                    <Link to="/investor-dashboard" className="nxl-link">Investor</Link>
                  </li>
                </ul>
              </li>
            )}

            {showSidebar && userData.role !== 5 && (
              <li className={`nxl-item nxl-hasmenu ${expandedMenus.projects ? 'nxl-trigger' : ''} ${projectActive ? 'active' : ''}`}>
                <button type="button" className="nxl-link border-0 bg-transparent p-0 w-100 text-start" onClick={() => toggleMenu('projects')}>
                  <span className="nxl-micon"><i className="feather-briefcase"></i></span>
                  <span className="nxl-mtext" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>Projects</span>
                  <span className="nxl-arrow" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>
                    <i className="feather-chevron-right"></i>
                  </span>
                </button>
                <ul className={`nxl-submenu ${expandedMenus.projects && !sidebarCollapsed ? 'show' : ''}`}>
                  <li className={`nxl-item nxl-hasmenu ${expandedMenus.invested ? 'nxl-trigger' : ''} ${investedActive || unreleasedActive || completedActive ? 'active' : ''}`}>
                    <button type="button" className="nxl-link border-0 bg-transparent p-0 w-100 text-start" onClick={() => toggleMenu('invested')}>
                      <span className="nxl-micon"><i className="feather-trending-up"></i></span>
                      <span className="nxl-mtext" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>Invested</span>
                      <span className="nxl-arrow" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>
                        <i className="feather-chevron-right"></i>
                      </span>
                    </button>
                    <ul className={`nxl-submenu ${expandedMenus.invested && !sidebarCollapsed ? 'show' : ''}`}>
                      <li className={`nxl-item ${pathname === '/invested' ? 'active' : ''}`}>
                        <Link to="/invested" className="nxl-link">All Invested</Link>
                      </li>
                      <li className={`nxl-item ${pathname === '/ongoing' ? 'active' : ''}`}>
                        <Link to="/ongoing" className="nxl-link">Ongoing</Link>
                      </li>
                      <li className={`nxl-item ${pathname === '/unreleased' ? 'active' : ''}`}>
                        <Link to="/unreleased" className="nxl-link">Not Released</Link>
                      </li>
                      <li className={`nxl-item ${pathname === '/completed' ? 'active' : ''}`}>
                        <Link to="/completed" className="nxl-link">Completed</Link>
                      </li>
                    </ul>
                  </li>
                  <li className={`nxl-item ${pathname === '/active' ? 'active' : ''}`}>
                    <Link to="/active" className="nxl-link">Active</Link>
                  </li>
                  <li className={`nxl-item ${upcomingActive ? 'active' : ''}`}>
                    <Link to="/upcoming" className="nxl-link">Upcoming</Link>
                  </li>
                  {(userData.role === 1 || userData.role === 2) && (
                    <li className={`nxl-item ${pathname === '/documents' ? 'active' : ''}`}>
                      <Link to="/documents" className="nxl-link">Documents</Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            <li className="nxl-item">
              <button type="button" className="nxl-link border-0 bg-transparent p-0 w-100 text-start" onClick={handleSignout}>
                <span className="nxl-micon"><i className="feather-log-out"></i></span>
                <span className="nxl-mtext" style={{ display: sidebarCollapsed ? 'none' : 'inline' }}>Logout</span>
              </button>
            </li>
          </ul>

          <div className="card text-center" style={{ display: sidebarCollapsed ? 'none' : 'block' }}>
            <div className="card-body">
              <i className="feather-sunrise fs-4 text-dark"></i>
              <h6 className="mt-4 text-dark fw-bolder">Investment Center</h6>
              <p className="fs-11 my-3 text-dark">Newtribe IMS - Your gateway to investment management.</p>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
